import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ResetPasswordResponse } from './reset-password.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ResetPasswordService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string,
  ) { }  

  public validateToken(token: string): Observable<ResetPasswordResponse> {
    var params = new HttpParams()
      .set('token', token)
    return this.http.get<ResetPasswordResponse>(this.apiUrl + 'auth/validate-token', {params});
  }

  public setPassword(body: { username: string; password: string; }){
    return this.http.post<ResetPasswordResponse>(this.apiUrl + 'auth/reset-password', body)
      .pipe(map(x => x.model));
  }
}
